module.exports = __webpack_public_path__ + "static/img/zzb_rz.ce616c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/zzb_rz.png
// module id = 8lus
// module chunks = 0